<template>
  <div class="dapp-root">

    <!-- top fixed menu -->
    <DAppNavigation></DAppNavigation>

    <!-- scroll container -->
    <div class="dapp-body">

      <!-- common header -->
      <!-- ... -->

      <!-- router controlled content -->
      <div class="dapp-content">
        <router-view/>
      </div>

      <!-- common footer -->
      <DAppFooter></DAppFooter>

    </div>
  </div>

</template>

<script>
  import DAppNavigation from './widgets/DAppNavigation'
  import DAppFooter from './widgets/DAppFooter'

  export default {
    name: 'App',
    components: {
      DAppNavigation,
      DAppFooter,
    },
  }
</script>

<style lang="scss">
  @import "./common";

  body {
    background: #EEE !important;
    font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 14px;
    color: rgba(0, 0, 0, .65);
  }

  .dapp-root {
    height: 100%;
    width: 100%;
  }

  /* 滚动容器 */
  .dapp-body {
    width: 100%;
    padding-top: $menu-height;
    min-height: 100%;
    display: flex;
    flex-direction: column;
  }

  .dapp-content {
    flex-grow: 1;
    width: 100%;
    margin: 30px auto;
    padding: 0 $horizontal-margin;

    @include respond-above(sm) {
      padding: 0 $horizontal-margin-desktop;
    }
  }

  .dapp-simple-content {
    max-width: 800px;
    margin: auto;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue